import React from 'react';
import '../styles/customtextfield.css';

const CustomDropdown = ({ label, name, options, value, onChange, required = false, placeholder }) => {
    const handleChange = (e) => {
        if (onChange) onChange(name, e.target.value);
    };

    const displayPlaceholder = placeholder || (label ? `Select ${label}` : 'Select');

    return (
        <div className="custom-text-field">
            <select
                name={name}
                value={value || ''}
                onChange={handleChange}
                required={required}
                className="custom-select"
            >
                <option value="">{displayPlaceholder}</option>
                {options && options.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CustomDropdown;